import {keyValueStore} from '../../../libs/shared/core/src/services/storage/storage';

/*
 * Constants.
 */

const recentQueriesKey = 'recentQueries';

/*
 * Recent search queries.
 */

export function readRecentSearchQueries(): ReadonlyArray<string> {
  const recentQueries = keyValueStore.read(recentQueriesKey);
  return recentQueries ? recentQueries.split(',') : [];
}

export function setRecentSearchQueries(queries: Array<string>) {
  keyValueStore.set(recentQueriesKey, queries.join(','));
}
